import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import apiInstanceV2 from "../../Apis/AxiosV2";
import {ATTENDANCE_SERVICE} from "../EndPoints";

/**
 * @Author: Arnulfo Ferro Zapata
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

export const GetGeofenceById = createAsyncThunk('attendanceGeoFence/getGeofenceById', async (id, { dispatch, getState }) => {
    const response = await apiInstance.get(`${ATTENDANCE_SERVICE.getGeofenceById}${id}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateGeofence = createAsyncThunk("attendanceGeoFence/createGeofence",async (params, { dispatch, getState }) => {
    const response = await apiInstance.post(`${ATTENDANCE_SERVICE.createGeofence}`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateGeofence = createAsyncThunk("attendanceGeoFence/updateGeofence",async (params, { dispatch, getState }) => {
    const response = await apiInstance.put(`${ATTENDANCE_SERVICE.updateGeofence}`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetGeofenceList = createAsyncThunk('attendanceGeoFence/getGeofenceList', async (params, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .get(`${ATTENDANCE_SERVICE.getGeofenceList}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const UpdateGeofenceHierarchyLevel = createAsyncThunk("attendanceGeoFence/updateGeofenceHierarchyLevel",async (params, { dispatch, getState }) => {
    const response = await apiInstance.put(`${ATTENDANCE_SERVICE.updateGeofenceHierarchyLevel}`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateGeofenceStatus = createAsyncThunk("attendanceGeoFence/updateGeofenceStatus",async (params, { dispatch, getState }) => {
    const response = await apiInstance.put(`${ATTENDANCE_SERVICE.updateGeofenceStatus}`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetGeofenceConfigSettingByGeofenceId = createAsyncThunk("attendanceGeoFence/getGeofenceConfigSetting",async (params, { dispatch, getState }) => {

    const response = await apiInstance.get(`${ATTENDANCE_SERVICE.getGeofenceConfigSetting}${params}`).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});
